<div class="topbar">
    <div id="topbar-left">
        <a id="omega-menu-button"
           href="#"
           (click)="appMain.toggleMenu($event)">
            <span class="pi pi-bars"></span>
        </a>
    </div>

    <a id="options-menu-button"
       href="#"
       (click)="appMain.toggleTopMenu($event)">
        <span class="pi pi-ellipsis-h"></span>
    </a>

    <button pButton
            type="button"
            icon="pi pi-plus"
            class="p-button-sm p-button-rounded p-button-outlined p-button-success"
            label="New Booking"
            (click)="newBooking()"
    ></button>

    <div id="topbar-icons"
         class="animated">
    <span class="topbar-search"
          (click)="appMain.onSearchClick()"
          style="width: 20rem;">
        <span class="search-icon pi pi-user text-pink-500"></span>
        <ng-container *ngIf="userSearch">
            <p-autoComplete [(ngModel)]="userSearch.term"
                            [showEmptyMessage]="true"
                            [suggestions]="userSearch.filteredModel"
                            (completeMethod)="userSearch.onFilter($event)"
                            (ngModelChange)="userSearch.onChanged($event)"
                            [style]="{'width':'90%'}"
                            [inputStyle]="{'width':'100%'}"
                            placeholder="Search by Name, Email, or Mobile"
                            field="label"
                            [minLength]="3">
            </p-autoComplete>
        </ng-container>
    </span>

        <span class="topbar-search"
              (click)="appMain.onSearchClick()"
              style="width: 20rem;">
        <span class="search-icon pi pi-shopping-cart text-orange-500"></span>
        <ng-container *ngIf="bookingSearch">
            <p-autoComplete [(ngModel)]="bookingSearch.term"
                            [showEmptyMessage]="true"
                            [suggestions]="bookingSearch.filteredModel"
                            (completeMethod)="bookingSearch.onFilter($event)"
                            (ngModelChange)="bookingSearch.onChanged($event)"
                            [style]="{'width':'90%'}"
                            [inputStyle]="{'width':'100%'}"
                            placeholder="Search by Invoice or Booking Code"
                            field="label"
                            [minLength]="6">
            </p-autoComplete>
        </ng-container>
        </span>

        <a (click)="op.toggle($event)"
           class="pointer"
           pTooltip="Merchant Setting"
           tooltipPosition="left">
            <img src="assets/images/avatar/{{avatarImage}}"
                 width="32">
        </a>

        <p-overlayPanel #op>
            <ng-template pTemplate>
                <p-menu [model]="items"></p-menu>
            </ng-template>
        </p-overlayPanel>
    </div>
</div>
